var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExpandedViewBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7066_9999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 16.5H3.75C2.50736 16.5 1.5 15.4926 1.5 14.25V3.75C1.5 2.50736 2.50736 1.5 3.75 1.5H11.25C12.4926 1.5 13.5 2.50736 13.5 3.75V6M15 16.5C14.1716 16.5 13.5 15.8284 13.5 15V6M15 16.5C15.8284 16.5 16.5 15.8284 16.5 15V7.5C16.5 6.67157 15.8284 6 15 6H13.5M4.5 5.25H10.5M4.5 9H10.5M4.5 12.75H7.5",
    stroke: "#7BABF5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7066_9999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExpandedViewBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/expanded_view_blue.3473f5eb0b33a7fecf767d63ce4bfbb5.svg";